import swal from "sweetalert";
import { loginConfirmedAction, Logout, refreshAccessToken} from '../store/actions/AuthActions';
import {loadProfile} from '../store/actions/ProfileAction'
import axiosAuthInstance from './AxiosAuthInstance';
import AxiosInstance from './AxiosInstance';
export function signUp(email, password) {
    const postData = {
        email,
        password
    };
    return axiosAuthInstance.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(authData) {
    const postData = {
        ...authData,
        returnSecureToken: true,
    };
    return axiosAuthInstance.post(`auth/login`,postData);
}

export function formatError(errorResponse) {
    switch (errorResponse.message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';
            
        case errorResponse.message:
            swal("Oops", errorResponse.message, "error",{ button: "Try Again!",});
            break;

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails, userDetails={}) {
    localStorage.setItem('LNT', tokenDetails.accessToken);
    localStorage.setItem('EXPT', tokenDetails.refreshToken);
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
}

export const refreshAccessTokenMain = async () => {
    try {
      const { store } = require('../store/store');
      const state = store.getState();
      const response = await AxiosInstance.post(`/auth/refresh-token`,
            { token: state?.auth?.auth.refreshToken },
            { withCredentials: true }
      )
      const newToken = response?.data?.data?.accessToken;
      localStorage.setItem('LNT', newToken);
      store.dispatch(refreshAccessToken(newToken));
      return newToken;
    } 
    catch (err) {
      console.error('Token refresh failed', err);
    }
};

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        dispatch(Logout(navigate, 'runLogoutTimer'));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate, 'checkAutoLogin'));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate, 'checkAutoLogin1'));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
    dispatch(loadProfile());
}
